/* tslint:disable */
/* eslint-disable */
/**
 * cellera-backend API spec
 * Backend Service for Cellera | [swagger.json](cellera/swagger.json)
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { AppointmentAppointmentTypeDto } from './AppointmentAppointmentTypeDto';
import {
    AppointmentAppointmentTypeDtoFromJSON,
    AppointmentAppointmentTypeDtoFromJSONTyped,
    AppointmentAppointmentTypeDtoToJSON,
    AppointmentAppointmentTypeDtoToJSONTyped,
} from './AppointmentAppointmentTypeDto';
import type { AppointmentPatientDto } from './AppointmentPatientDto';
import {
    AppointmentPatientDtoFromJSON,
    AppointmentPatientDtoFromJSONTyped,
    AppointmentPatientDtoToJSON,
    AppointmentPatientDtoToJSONTyped,
} from './AppointmentPatientDto';

/**
 * 
 * @export
 * @interface AppointmentResponseDto
 */
export interface AppointmentResponseDto {
    /**
     * Appointment ID
     * @type {string}
     * @memberof AppointmentResponseDto
     */
    id: string;
    /**
     * Appointment date
     * @type {Date}
     * @memberof AppointmentResponseDto
     */
    appointmentDate: Date;
    /**
     * Start time in HH:MM format
     * @type {Date}
     * @memberof AppointmentResponseDto
     */
    startTime: Date;
    /**
     * End time in HH:MM format
     * @type {Date}
     * @memberof AppointmentResponseDto
     */
    endTime: Date;
    /**
     * Patient ID
     * @type {string}
     * @memberof AppointmentResponseDto
     */
    patientId: string;
    /**
     * Provider ID
     * @type {string}
     * @memberof AppointmentResponseDto
     */
    providerId: string;
    /**
     * Practice category
     * @type {AppointmentAppointmentTypeDto}
     * @memberof AppointmentResponseDto
     */
    appointmentType: AppointmentAppointmentTypeDto;
    /**
     * Practice ID
     * @type {string}
     * @memberof AppointmentResponseDto
     */
    practiceId: string;
    /**
     * Notes
     * @type {string}
     * @memberof AppointmentResponseDto
     */
    notes: string;
    /**
     * patient
     * @type {AppointmentPatientDto}
     * @memberof AppointmentResponseDto
     */
    patient: AppointmentPatientDto;
}

/**
 * Check if a given object implements the AppointmentResponseDto interface.
 */
export function instanceOfAppointmentResponseDto(value: object): value is AppointmentResponseDto {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('appointmentDate' in value) || value['appointmentDate'] === undefined) return false;
    if (!('startTime' in value) || value['startTime'] === undefined) return false;
    if (!('endTime' in value) || value['endTime'] === undefined) return false;
    if (!('patientId' in value) || value['patientId'] === undefined) return false;
    if (!('providerId' in value) || value['providerId'] === undefined) return false;
    if (!('appointmentType' in value) || value['appointmentType'] === undefined) return false;
    if (!('practiceId' in value) || value['practiceId'] === undefined) return false;
    if (!('notes' in value) || value['notes'] === undefined) return false;
    if (!('patient' in value) || value['patient'] === undefined) return false;
    return true;
}

export function AppointmentResponseDtoFromJSON(json: any): AppointmentResponseDto {
    return AppointmentResponseDtoFromJSONTyped(json, false);
}

export function AppointmentResponseDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): AppointmentResponseDto {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'appointmentDate': (new Date(json['appointmentDate'])),
        'startTime': (new Date(json['startTime'])),
        'endTime': (new Date(json['endTime'])),
        'patientId': json['patientId'],
        'providerId': json['providerId'],
        'appointmentType': AppointmentAppointmentTypeDtoFromJSON(json['appointmentType']),
        'practiceId': json['practiceId'],
        'notes': json['notes'],
        'patient': AppointmentPatientDtoFromJSON(json['patient']),
    };
}

export function AppointmentResponseDtoToJSON(json: any): AppointmentResponseDto {
    return AppointmentResponseDtoToJSONTyped(json, false);
}

export function AppointmentResponseDtoToJSONTyped(value?: AppointmentResponseDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'appointmentDate': ((value['appointmentDate']).toISOString()),
        'startTime': ((value['startTime']).toISOString()),
        'endTime': ((value['endTime']).toISOString()),
        'patientId': value['patientId'],
        'providerId': value['providerId'],
        'appointmentType': AppointmentAppointmentTypeDtoToJSON(value['appointmentType']),
        'practiceId': value['practiceId'],
        'notes': value['notes'],
        'patient': AppointmentPatientDtoToJSON(value['patient']),
    };
}

